export function isVertical(rotation) {
    return rotation === 1 || rotation === 3;
}
export function rotate(rotation, direction) {
    return ((rotation + direction + 4) % 4);
}
/** Две клетки капсулы с цветами и связями. */
export function pieceCells(piece) {
    const { x, y, rotation } = piece;
    const [first, second] = piece.colors;
    switch (rotation) {
        case 0:
            return [
                { x, y, color: first, link: 'right' },
                { x: x + 1, y, color: second, link: 'left' },
            ];
        case 1:
            return [
                { x, y: y - 1, color: first, link: 'down' },
                { x, y, color: second, link: 'up' },
            ];
        case 2:
            return [
                { x, y, color: second, link: 'right' },
                { x: x + 1, y, color: first, link: 'left' },
            ];
        case 3:
            return [
                { x, y: y - 1, color: second, link: 'down' },
                { x, y, color: first, link: 'up' },
            ];
    }
}
//# sourceMappingURL=piece.js.map